var map = {
	"./loading.svg": 2725,
	"./mark-preview-2p.png": 91020,
	"./mark-preview-2p.svg": 4274,
	"./mark-preview-3p.png": 3991,
	"./mark-preview-3p.svg": 27821,
	"./mark-preview.png": 35171,
	"./mark-preview.svg": 64091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82093;